module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "ng2-alfresco-core"
// module id = 2
// module chunks = 0